import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Monitor, Briefcase, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const HeroDual = () => {
  return (
    <section className="py-4">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-4">
          {/* Business segment */}
          <Link 
            to="/catalogo?segment=empresa"
            className={cn(
              "group relative overflow-hidden rounded-lg",
              "gradient-hero-business text-white",
              "p-8 md:p-10 min-h-[280px]",
              "flex flex-col justify-between",
              "hover:shadow-elevated transition-shadow duration-300"
            )}
          >
            <div className="relative z-10">
              <div className="flex items-center gap-2 mb-2">
                <Briefcase className="h-5 w-5" />
                <span className="text-white/80 text-sm font-medium">Para empresas</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold mb-2">
                Para tu empresa
              </h2>
              <p className="text-white/80 max-w-xs">
                La confianza y seguridad que necesitas para tu negocio
              </p>
            </div>
            
            <div className="flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all">
              <span>Comprar ahora</span>
              <ArrowRight className="h-4 w-4" />
            </div>

            {/* Decorative elements */}
            <div className="absolute right-4 bottom-4 opacity-20 group-hover:opacity-30 transition-opacity">
              <Monitor className="h-32 w-32" />
            </div>
          </Link>

          {/* Personal segment */}
          <Link 
            to="/catalogo?segment=personal"
            className={cn(
              "group relative overflow-hidden rounded-lg",
              "gradient-hero-personal text-white",
              "p-8 md:p-10 min-h-[280px]",
              "flex flex-col justify-between",
              "hover:shadow-elevated transition-shadow duration-300"
            )}
          >
            <div className="relative z-10">
              <div className="flex items-center gap-2 mb-2">
                <Monitor className="h-5 w-5" />
                <span className="text-white/80 text-sm font-medium">Para el hogar</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold mb-2">
                Para tu vida personal
              </h2>
              <p className="text-white/80 max-w-xs">
                El estilo y variedad que mereces para tu día a día
              </p>
            </div>
            
            <div className="flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all">
              <span>Comprar ahora</span>
              <ArrowRight className="h-4 w-4" />
            </div>

            {/* Decorative elements */}
            <div className="absolute right-4 bottom-4 opacity-20 group-hover:opacity-30 transition-opacity">
              <Briefcase className="h-32 w-32" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroDual;
